<template>
  <div v-if="$slots.trigger" class="help-popup">
    <slot name="trigger" />
    <md-tooltip :md-direction="direction" :class="type">
      <div>
        <slot />
      </div>
    </md-tooltip>
  </div>
  <span v-else class="help-tooltip" :class="{ invert: invert }">
    <md-icon
      v-if="type === 'error'"
      class="tooltip-icon error"
      :class="{ invert: invert }"
      :md-src="require('../assets/images/help-tooltip-error.svg')"
    />
    <md-icon
      v-if="type === 'warning'"
      class="tooltip-icon warning"
      :class="{ invert: invert }"
      :md-src="require('../assets/images/help-tooltip-warning.svg')"
    />
    <md-icon v-if="type === 'help'" class="tooltip-icon info" :md-src="require('../assets/images/help-tooltip-info-question.svg')" />
    <md-icon v-if="type === 'info'" class="tooltip-icon info" :md-src="require('../assets/images/help-tooltip-info-exclamation.svg')" />
    <md-tooltip :md-direction="direction" :class="type">
      <div>
        <slot />
      </div>
    </md-tooltip>
  </span>
</template>

<script>
export default {
  name: 'help-tooltip',
  props: {
    type: {
      type: String,
      default: 'info',
    },
    direction: {
      type: String,
      default: 'right',
    },
    invert: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
  },
};
</script>

<style scoped>
.help-tooltip {
  display: inline-block;
  cursor: pointer;
  margin-left: 4px;
  width: 22px;
  height: 22px;
}

.help-popup {
  display: inline-block;
}

.help-tooltip.invert {
  margin-left: 0;
  margin-right: 4px;
}

.help-tooltip i {
  min-width: unset;
  width: 22px;
  height: 22px;
  font-size: unset !important;
}

.md-svg-loader {
  display: inline-block;
}

.tooltip-icon.error >>> svg .background {
  fill: #f92c2d !important;
}

.tooltip-icon.warning >>> svg .background {
  fill: #f2994a !important;
}

.tooltip-icon.info >>> svg .background {
  fill: #262736 !important;
}

.tooltip-icon.error >>> svg .foreground,
.tooltip-icon.warning >>> svg .foreground,
.tooltip-icon.info >>> svg .foreground {
  fill: white !important;
}

.tooltip-icon.invert.error >>> svg .background {
  fill: white !important;
}

.tooltip-icon.invert.warning >>> svg .background  {
  fill: white !important;
}

.tooltip-icon.invert.info >>> svg .background {
  fill: white !important;
}

.tooltip-icon.invert.error >>> svg .foreground {
  fill: #f92c2d !important;
}
.tooltip-icon.invert.warning >>> svg .foreground {
  fill: #f2994a !important;
}
.tooltip-icon.invert.info >>> svg .foreground {
  fill: #262736 !important;
}

</style>
